'use strict';

function Environment() {

    this.initEnvironment = function () {
        this.setEnvironmentTitle();
    };

    /********************************/
    // set environment
    /********************************/
    this.setEnvironmentTitle = function () {
        var environmentTitle = '';
        var host = window.location.hostname;
        var bits = host.split('.');
        if (bits.length > 0) {
            var serverName = bits[0];
            switch (serverName) {
                case 'e-vision-dev':
                    environmentTitle = 'Dev';
                    break;
                case 'e-vision-test':
                    environmentTitle = 'Test';
                    break;
                case 'e-vision-proc':
                    environmentTitle = 'Proc';
                    break;
            }

            if(environmentTitle !== ''){
                $('#environment-header').removeClass(environmentTitle.toLowerCase()).addClass(environmentTitle.toLowerCase());

                environmentTitle = environmentTitle.toUpperCase();

                $('#applicationEnvironment').each(function(){
                    $(this).find('li > a').find('strong').remove();
                    $(this).show().find('li > a').append('<strong>' + environmentTitle + '</strong>');
                });
            }
        }
    };
}
